class articleIndex {
  constructor($t) {
    this.$t = $t;
    this.$indexTriggers = document.querySelectorAll('[aria-controls="index-nav"]');
    this.$lists = this.$t.querySelector('.ari-lists');
    this.$listsItems = this.$lists.querySelectorAll('.ari-lists-item');

    this.$indexTriggers.forEach($trigger => {
      $trigger.addEventListener('click', event => {
        event.preventDefault();
        this._toggle($trigger);
        return false;
      });
    });

    this.$listsItems.forEach($item => {
      const $link = $item.querySelector(':scope > a');
      $link.addEventListener('click', event => {
        event.preventDefault();
        this._scroll($link);
      });
    });
  };
  _toggle = $trigger => {
    let controls = $trigger.getAttribute('aria-controls');
    let $target = document.querySelector(`#${controls}`);
    let isExpanded = $trigger.getAttribute('aria-expanded');
    let isHidden = true;
    if (isExpanded === 'false') {
      isExpanded = true;
      isHidden = false;
    } else {
      isExpanded = false;
      isHidden = true;
    };
    this.$indexTriggers.forEach($trigger => {
      $trigger.setAttribute('aria-expanded', isExpanded);
    });
    $target.setAttribute('aria-hidden', isHidden);
    if ($target.style.height === '0px' || $target.style.height === '') {
      $target.style.height = `${$target.scrollHeight}px`;
    } else {
      $target.style.height = '0px';
    };
  };
  _scroll = $link => {
    let hh = document.querySelector('.Header').offsetHeight;
    let id = $link.getAttribute('href');
    let $target = document.querySelector(id);
    if ($target) {
      let targetPosition = $target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: targetPosition - hh,
        behavior: 'smooth'
      });
      history.pushState(null, null, id);
    };
  };
};

const $articleIndex = document.querySelector('.article-index');
if ($articleIndex) new articleIndex($articleIndex);